import template from './picq.html';
import controller from './picq.controller';
import './picq.styl';

let picqComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default picqComponent;



// WEBPACK FOOTER //
// ./client/app/common/reports/picq/picq.component.js